<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <water-field-form-group
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></water-field-form-group>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <water-sample-form-group
          v-for="(sample, index) in submission_data.samples"
          :key="index"
          :sample="sample"
          :addOns="addOns"
          :index="index"
          :usageOptions="usageOptions"
          @onSampleChange="onSampleChange"
        ></water-sample-form-group>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :serviceQuestion="serviceQuestion"
          :key="index"
        ></service-question>
      </div>
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import WaterFieldFormGroup from "./WaterFieldFormGroup";
import WaterSampleFormGroup from "./WaterSampleFormGroup";
import TurnAroundSelect from "../../TurnAroundSelect";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "WaterForm",
  components: {
    WaterFieldFormGroup,
    WaterSampleFormGroup,
    TurnAroundSelect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    index: {
      type: Number,
      default: null
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    usageOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  validations: {
    submission_data: {
      identifier: { required }
    }
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    }
  },
  watch: {
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
